export default async function apiFetch(url, options = {}) {
  const token = localStorage.getItem('access_token');

  const headers = {
    Accept: 'application/json',
    ...(options.headers || {}),
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };

  const res = await fetch(url, { ...options, headers });

  if (res.status === 401 || res.status === 403) {
    localStorage.removeItem('access_token');
    window.location.href = '/login';
    throw new Error('Authentication failed');
  }

  return res;
}
